<template>
  <div>
    <v-row no-gutters>
      <v-col class="ml-4 font18  " :style="{'color': $CUSTOMMainTextColor}"><div class="pb-0" :style="isTargetShop ? 'font-size: 20px;' : ''"> {{ isTargetShop ?  $t("message.allCampaign") : $t("message.allPromotion")}}</div></v-col>
    </v-row>
     <v-card
        class="ml-4 mr-4 mb-5 mt-4 pa-2"
        style="border-radius: 20px;"
        width="93%"
        elevation="3"
        v-if="!items && show"
        height="100%"
          flat
        tile
      >
         <v-skeleton-loader height="50vh"
          type="article,list-item-three-line"
        ></v-skeleton-loader>
      </v-card>
    <v-card
      v-for="(item, i) in items"
      :key="i"
      width="93%"
      class="ml-4 mr-4 mb-5 mt-4 pa-3"
      style="border-radius: 8px;"
      elevation="0"
        flat
        tile
    >
      <div style="display: flex">
        <div style="height: 120px; width: 170px">
          <v-img
            :src="item.promotionPicture"
            height="100%"
            width="140"
            class="link"
            :style="item.quotaCode <= 0? 'opacity: 0.5;'+$isTargetShop ?'border-radius: 0px;':'border-radius: 12px;' : 'opacity: 1;' + $isTargetShop ?'border-radius: 0px;':'border-radius: 12px;'"
             @click="$isTargetShop ? $router.push(`/C/promotion/detail/${item.id}`) : $router.push(`/promotion/detail/${item.id}`)"
             cover
          >
          </v-img>
        </div>
        <div style="padding: 8px; position: relative; width: 100vh">
          <div height="100" v-if="$i18n.locale === 'th' || item.promotionNameEng === '' || item.promotionNameEng === null">
            <div class="font16 bold " @click="$router.push(`/reward/detail/${item.rewardId}`)" :style="{'color': $CUSTOMMainTextColor}">{{ item.promotionName.substring(0, 79) }}</div>
          </div>
          <div height="100" v-else>
            <div class="font16 bold " @click="$router.push(`/reward/detail/${item.rewardId}`)" :style="{'color': $CUSTOMMainTextColor}">{{ item.promotionNameEng.substring(0, 79) }}</div>
          </div>
          <!-- {{item}} -->
          <div v-if="item.promotionExpiryDate && item.promotionExpiryDate !== '' && item.promotionExpiryDate !== null && item.promotionExpiryDate !== 'None' || item.limitExpri" class="text-caption mt-1" :style="{'color': $CUSTOMMainTextColor}">
            {{ $t("message.validUntil") || "ใช้ได้ถึง" }} {{ formatDate(item.promotionExpiryDate)  || item.limitExpri}}
          </div>
          <!-- <div height="100" v-show="item.promotionDetailsEng.length <= 49">
            <div class="font14" @click="$router.push(`/reward/detail/${item.rewardId}`)">{{ item.promotionDetails.substring(0, 41) }}</div>
          </div> -->
          <div style="position: absolute;bottom: 10px;width: 91%;">
            <div
              class="bold"
              :style="$isTargetShop? 'color: #000;background-color:' + '#FFA300' + ';border-radius: 0px;box-shadow: none;'  :'color:' + $textcolor + ';background-color:' + $bgColor + ';' "
              style="text-align: center;display:flex;padding:3px;font-size: 15px;justify-content: center;"
              @click="$isTargetShop ? $router.push(`/C/promotion/detail/${item.id}`) : $router.push(`/promotion/detail/${item.id}`)"
              >
              <div>
                {{ $t("message.viewDetails") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    <!-- <v-card-text>
      <v-row>
        <v-col class="col-5 pt-0">
          <v-img
            :src="item.promotionPicture"
            style=" width: 100%; height: auto;"
            class="link"
            @click="$router.push(`/promotion/detail/${item.id}`)"
          >
          </v-img>
        </v-col>
        <v-col class="col-7">
          <v-row class="font16 bold headline1">
            <v-col class="pl-0 pt-2 pb-3">{{ item.promotionName }}</v-col>
          </v-row>
          <v-row class="font14 headline1">
            <v-col class="pl-0 pt-0 pb-3">{{ item.promotionSubName }} </v-col>
          </v-row>
        </v-col>
      </v-row>
      </v-card-text>
      <v-card-actions style="display: flex; justify-content: right;">
        <div>
           <v-btn
                block
                outlined
                rounded
                x-small
                class="headline1"
                @click="$router.push(`/promotion/detail/${item.id}`)"
                >เข้าชมรายละเอียด</v-btn
              >
        </div>
      </v-card-actions> -->
    </v-card>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'AllPromotion',
  data () {
    return {
      items: null,
      member: null,
      profile: null,
      show: false,
      shopId: null
    }
  },
  computed: {
    isTargetShop () {
      return this.$isTargetShop()
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    this.shopId = this.GET_SHOPID()
    this.member = this.GET_MEMBERINFO()
    this.profile = this.getLiffProfile()
    await this.getAllPromotion()
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),
    ...mapGetters('shopStore', ['GET_SHOPID']),

    formatDate (dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      const options = { year: 'numeric', month: 'short', day: 'numeric' }
      return date.toLocaleDateString('th-TH', options)
    },

    async getAllPromotion () {
      const result = await this.callBeTaskAPI(
        'get',
        `/promotion/get?RECORD_STATUS=N&shopId=${this.$shopId}`
      )
      if (result) {
        this.items = result.filter(item => {
          if (item.promotionExpiryDate && item.promotionExpiryDate !== '' && item.promotionExpiryDate !== null && item.promotionExpiryDate !== 'None') {
            return new Date(item.promotionExpiryDate) > new Date()
          } else {
            return item
          }
        })
      }
      this.show = true
    }
  }
}
</script>
<style scoped>
.v-sheet.v-card {
    background-color: white !important;
}
</style>



// WEBPACK FOOTER //
// src/components/HomeCUSTOM/Promotion/AllPromotion.vue